import React from "react";
import styled from "styled-components";

interface LoginErrorMessageProps {
  msg: string;
}

export default function LoginErrorMessage({ msg }: LoginErrorMessageProps) {
  return (
    <ErrorMessage>
      <span className="material-icons-outlined">report_problem</span>
      {msg}
    </ErrorMessage>
  );
}

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.buttonColor.redNormal};

  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;

  span {
    font-size: 18px;
    margin-right: 4px;
  }
`;
